export class entity{
    assetNo =[
        {benumber : 'JHNANR019',cost_center:'JHR070-K-MUR',begroup:'PS',becode:'ME-010N',beGeneralName:'ANALYZERS,LABORATORY,URINE,Semiautomated',beCndSts:'ACT',beCategory:'ANALYZERS,LABORATORY,URINE,Semiautomated',circle:'SC3',district:'MUAR',zone:'Southern',clinicCide:'JHR070'}
    ];
}